'use client';

import { usePathname } from 'next/navigation';
import { useEffect, useRef } from 'react';
import {
  getSessionItem,
  removeSessionItem,
  setSessionItem,
} from 'app/_lib/utils/sessionStorage';

export const CURRENT_PATHNAME_STORAGE_KEY = 'currentPathname';
export const PREVIOUS_PATHNAME_STORAGE_KEY = 'previousPathname';

//check if user left site
function getSameOriginReferrerPathname() {
  if (!document.referrer) return null;

  try {
    const referrer = new URL(document.referrer);
    if (referrer.origin !== window.location.origin) return null;
    return referrer.pathname;
  } catch {
    return null;
  }
}

export default function PreviousPathnameTracker() {
  const pathname = usePathname();
  const isInitialLoad = useRef(true);

  useEffect(() => {
    if (!pathname) return;

    //rest pathname storage if user has left site
    if (isInitialLoad.current) {
      isInitialLoad.current = false;

      const referrerPathname = getSameOriginReferrerPathname();

      if (referrerPathname)
        setSessionItem(PREVIOUS_PATHNAME_STORAGE_KEY, referrerPathname);
      else removeSessionItem(PREVIOUS_PATHNAME_STORAGE_KEY);

      setSessionItem(CURRENT_PATHNAME_STORAGE_KEY, pathname);
      return;
    }

    const currentPathname = getSessionItem(CURRENT_PATHNAME_STORAGE_KEY);

    if (pathname === currentPathname) return;

    if (currentPathname) {
      setSessionItem(PREVIOUS_PATHNAME_STORAGE_KEY, currentPathname);
    }

    setSessionItem(CURRENT_PATHNAME_STORAGE_KEY, pathname);
  }, [pathname]);

  return null;
}
